import './App.css'
import { ToastContainer } from 'react-toastify'
import Routing from './Routing/Routing'
import ReactGA from 'react-ga4';
import { NotificationProvider } from './Context/NotificationContext'
import NotificationModal from './Components/Common/NotificationModal'

const TRACKING_ID = "G-W0WXHB8BHZ";
ReactGA.initialize(TRACKING_ID);

const App = () => {
  return (
    <NotificationProvider>
      <Routing />
      <NotificationModal />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </NotificationProvider>
  )
}

export default App
